// Helper to append asset version for cache-busting
export const asset = (p: string): string => {
  const v = process.env.REACT_APP_ASSET_VERSION;
  return v ? `${p}?v=${v}` : p;
};

export default asset;
